import { Component, EventEmitter } from "@angular/core";

/**
 * The body of the modal that `AdminAuthService.askLogin` shows when a save finds no admin
 * session: why it appeared, then the admin login form.
 */
@Component({
  templateUrl: "./adminlogin.component.html",
})
export class AdminLoginComponent {
  message: string = "";
  loggedIn: EventEmitter<void> = new EventEmitter<void>();
}
